import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { AlertType, SortType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import AddIcon from "@mui/icons-material/Add";
import { tableStyle } from "../parametrage/Pays/Pays";
import { DataRef } from "../../../types/DataRef";
import Cookies from "universal-cookie";
import OptionalWidthModal from "../../../commons/optional-width-modal/OptionalWidthModal";
import { AllMounth, yearsToDisplay } from "../../../constants/Constants";
import axios, { AxiosInstance } from "axios";
import { urlApi } from "../parametrage/Pays/RowPays";
import { IYearsVerouillageClotureLocked } from "./ColumnHeader";
import CheckAttr from "../../../utils/CheckAttr";
import AddBudgetReforecastForm from "../../forms/Budget/AddBudgetReforecastForm";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loggoutUser } from "../../../redux/actions/logginUser";

interface FilterParams {
  pays?: string;
  bu?: string;
  client?: string;
  operation?: string;
  article?: string;
  month?: string;
  year?: string;
}

interface clientBudgetProd {
  id: number;
  libelle: string;
  is_clientBudget?: boolean;
}

interface operationBudgetProd {
  id: number;
  libelle: string;
  is_operationBudget?: boolean;
}

export interface ISumBudget {
  annee: number;
  ca_budget_sum: number;
  marge_sum: number;
  mois?: number;
}

const initialFilter: FilterParams = {
  pays: "",
  bu: "",
  client: "",
  operation: "",
  article: "",
  month: "",
  year: `${new Date().getFullYear()}`,
};

const initialDateVerouillageCloture: IYearsVerouillageClotureLocked = {
  YearsClotureBudget: [],
  YearsVerouillageBudget: [],
};

const StyledTableCellTittle = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

export const dataTypeConsolidation: DataRef[] = [
  { id: 1, libelle: "Annuelle" },
  { id: 2, libelle: "détail mensuel" },
];

const ConsolidationBudget = () => {
  let model = "Budget";
  

  const [dataFilteredPays, setDataFilteredPays] = useState<DataRef[]>([]);
  const [dataBusinessUnits, setDataBusinessUnits] = useState<DataRef[]>([]);
  const [dataClients, setDataClients] = useState<clientBudgetProd[]>([]);
  const [dataOperations, setDataOperations] = useState<operationBudgetProd[]>(
    []
  );
  const [dataArticle, setDataArticle] = useState<DataRef[]>([]);
  const [dataPaysInAssociations, setDataPaysInAssociations] = useState<
    DataRef[]
  >([]);
  const [dateVerrouillageCloture, setDateVerrouillageCloture] =
    useState<IYearsVerouillageClotureLocked>(initialDateVerouillageCloture);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [dataConsolidationBudget, setDataConsolidationBudget] = useState<
    ISumBudget[]
  >([]);

  const [filterParams, setFilterParams] = useState<FilterParams>(initialFilter);
  const [typeConsolidation, setTypeConsolidation] = useState<number>(1);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [openSnack, setOpenSnack] = useState<boolean>(false);

  // Token
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove("jwt", { path: "/" });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  // Function

  const getPaysByBudget = async () => {
    await http
      .post("budget/get/pays/by/model", { model })
      .then((res) => {
        Array.isArray(res.data) && setDataFilteredPays(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBuByBudget = async () => {
    await http
      .post("budget/get/bu/by/model/pays", {
        pays: filterParams?.pays,
        model,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataBusinessUnits(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getClientByBuPaysBudget = async () => {
    await http
      .post("budget/get/client/prod-budget/by/model/pays/bu", {
        pays: filterParams?.pays,
        bu: filterParams?.bu,
        // model,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getOperationByClientBuPaysBudget = async () => {
    await http
      .post("budget/get/operation/prod-budget/by/model/pays/bu/client", {
        pays: filterParams?.pays,
        bu: filterParams?.bu,
        client: filterParams?.client,
        clientIsBudget: dataClients?.find(
          (cl) => cl.id === Number(filterParams.client)
        )?.is_clientBudget,
        // model,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataOperations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAllArticle = async () => {
    setIsLoading(true);
    await http
      .post("budget/by/operation/pays/get-article", {
        pays: filterParams?.pays,
        bu: filterParams?.bu,
        client: filterParams?.client,
        operation: filterParams?.operation,
        clientIsBudget: dataClients?.find(
          (cl) => cl.id === Number(filterParams.client)
        )?.is_clientBudget,
        operationIsBudget: dataOperations?.find(
          (op) => op.id === Number(filterParams.operation)
        )?.is_operationBudget,
      })
      .then((res) => {
        Array.isArray(res.data) && setDataArticle(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getConsolidation = () => {
    const data = {
      typeConsolidation: typeConsolidation,
      filter: filterParams,
      clientIsBudget: dataClients?.find(
        (cl) => cl.id === Number(filterParams.client)
      )?.is_clientBudget,
      operationIsBudget: dataOperations?.find(
        (op) => op.id === Number(filterParams.operation)
      )?.is_operationBudget,
    };

    setIsLoading(true);
    http
      .post("budget/consolidation/list", data)
      .then((res) => {
        Array.isArray(res.data) && setDataConsolidationBudget(res.data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getPaysInAssociation = () => {
    // Récupère tous les pays qui existe dans l'association pays-bu
    http
      .get("pivot-client-bu/get-all-exist-pays-in-association")
      .then((res) => {
        Array.isArray(res.data) && setDataPaysInAssociations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDateVerouillaCloture = () => {
    // On Prend Le Date Veouillage et Date Cloture Now
    http
      .get("budget/get-year/verouillage-cloture-locked")
      .then((res) => {
        setDateVerrouillageCloture(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const reloadList = (reloadMenuItem: boolean = true) => {
    getConsolidation();
  };

  const getFilterTitle = (filters: FilterParams) => {
    if (CheckAttr(filters.operation) && Number(filters.operation) !== 0)
      return `Budget ${
        CheckAttr(filters.operation) &&
        "de l'opération " +
          dataOperations?.find((x) => x.id === Number(filters.operation))
            ?.libelle
      }`;
    if (CheckAttr(filters.client) && Number(filters.client) !== 0)
      return `Budget ${
        CheckAttr(filters.client) &&
        "du Client " +
          dataClients?.find((x) => x.id === Number(filters.client))?.libelle
      }`;
    if (CheckAttr(filters.bu) && Number(filters.bu) !== 0)
      return `Budget ${
        CheckAttr(filters.bu) &&
        "du BU " +
          dataBusinessUnits?.find((x) => x.id === Number(filters.bu))?.libelle
      }`;
    if (CheckAttr(filters.pays) && Number(filters.pays) !== 0)
      return `Budget ${
        CheckAttr(filters.pays) &&
        "du pays " +
          dataFilteredPays?.find((x) => x.id === Number(filters.pays))?.libelle
      }`;
    // ... autres cas
  };

  // Use Effect
  useEffect(() => {
    getPaysByBudget();
    getPaysInAssociation();
    getDateVerouillaCloture();
  }, []);

  useEffect(() => {
    if (filterParams?.pays) {
      getBuByBudget();
    } else {
      setDataBusinessUnits([]);
      setDataClients([]);
      setDataOperations([]);
      setDataArticle([]);
    }
    setFilterParams({
      ...filterParams,
      article: "",
      bu: "",
      client: "",
      operation: "",
    });
  }, [filterParams?.pays]);

  useEffect(() => {
    if (filterParams?.bu) {
      getClientByBuPaysBudget();
    } else {
      setDataClients([]);
      setDataOperations([]);
      setDataArticle([]);
    }
    setFilterParams({
      ...filterParams,
      article: "",
      client: "",
      operation: "",
    });
  }, [filterParams?.bu]);

  useEffect(() => {
    if (filterParams?.client) {
      getOperationByClientBuPaysBudget();
    } else {
      setDataOperations([]);
      setDataArticle([]);
    }
    setFilterParams({
      ...filterParams,
      article: "",
      operation: "",
    });
  }, [filterParams?.client]);

  useEffect(() => {
    if (filterParams?.operation) {
      getAllArticle();
    }
    setFilterParams({
      ...filterParams,
      article: "",
    });
  }, [filterParams?.operation]);

  useEffect(() => {
    getConsolidation();
  }, [filterParams, typeConsolidation]);

  // handle Change
  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;
    setFilterParams({
      ...filterParams,
      [name]: value,
    });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <>
      <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
        <Grid item xs={2} sm={0} md={2} spacing={1.5}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            color="warning"
            sx={{ textTransform: "none", marginBottom: { xs: 2 } }}
            onClick={() => setOpenModal(true)}
          >
            Ajouter
          </Button>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(typeConsolidation)}
            >
              Type Consolidation
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="pays"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Pays"
              value={typeConsolidation}
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  month: "0",
                });
                setTypeConsolidation(e.target.value as number);
              }}
            >
              <MenuItem value={0}></MenuItem>
              {dataTypeConsolidation.map((type) => (
                <MenuItem key={type?.id} value={type?.id} dense>
                  {type?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={
                CheckAttr(filterParams?.pays) && filterParams?.pays !== "0"
              }
            >
              Pays
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="pays"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Pays"
              value={filterParams?.pays}
              onChange={handleChangeFilter}
            >
              <MenuItem value={0}></MenuItem>
              {dataFilteredPays.map((pays) => (
                <MenuItem key={pays?.id} value={pays?.id} dense>
                  {pays?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(filterParams?.bu)}
            >
              Business unit
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="bu"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Business unit"
              value={filterParams?.bu}
              onChange={handleChangeFilter}
            >
              <MenuItem key={0} value={0}></MenuItem>
              {dataBusinessUnits.map((bu) => (
                <MenuItem key={bu?.id} value={bu?.id} dense>
                  {bu?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(filterParams?.client)}
            >
              Client
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="client"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Client"
              value={filterParams?.client}
              onChange={handleChangeFilter}
            >
              <MenuItem value={0}></MenuItem>
              {dataClients.map((client) => (
                <MenuItem key={client?.id} value={client?.id} dense>
                  {client?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={CheckAttr(filterParams?.operation)}
            >
              Opération
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="operation"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="Opération"
              value={filterParams?.operation}
              onChange={handleChangeFilter}
            >
              <MenuItem value={0}></MenuItem>
              {dataOperations.map((operation) => (
                <MenuItem key={operation?.id} value={operation?.id} dense>
                  {operation?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl fullWidth>
            <InputLabel
              id="demo-simple-select-label"
              color="warning"
              sx={{ mt: -1 }}
              shrink={
                CheckAttr(filterParams?.article) &&
                filterParams?.article !== "0"
              }
            >
              Article
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              name="article"
              sx={{ background: "#fff" }}
              size="small"
              color="warning"
              label="article"
              value={filterParams?.article}
              onChange={handleChangeFilter}
            >
              <MenuItem value={0}></MenuItem>
              {dataArticle.map((art) => (
                <MenuItem key={art?.id} value={art?.id} dense>
                  {art?.libelle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              htmlFor="Mois"
              color="warning"
              shrink={CheckAttr(filterParams?.month)}
              sx={{ mt: -1 }}
            >
              Mois
            </InputLabel>
            <Select
              id="Mois"
              native
              color="warning"
              sx={{ background: "#fff" }}
              size="small"
              value={filterParams?.month}
              name="month"
              onChange={handleChangeFilter}
              label="Mois"
              disabled={typeConsolidation === 1}
            >
              <option value={0}></option>
              {AllMounth.map((m) => (
                <option value={m.id}>{m.mounth}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sm={2} md={1.25}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              htmlFor="year"
              color="warning"
              shrink={CheckAttr(filterParams?.year)}
              sx={{ mt: -1 }}
            >
              Année
            </InputLabel>
            <Select
              id="year"
              native
              color="warning"
              sx={{ background: "#fff" }}
              size="small"
              name="year"
              value={filterParams?.year}
              onChange={handleChangeFilter}
              label="year"
              inputProps={{
                name: "year",
              }}
            >
              <option value={0}></option>
              {yearsToDisplay.map((y) => (
                <option value={y}>{y}</option>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <br></br>
      <TableContainer component={Paper} style={tableStyle} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCellTittle
                align="center"
                colSpan={typeConsolidation !== 1 ? 4 : 3}
              >
                <Typography
                  sx={{ flex: "1 1 100%" }}
                  variant="h6"
                  id="tableTitle"
                  component="div"
                >
                  {getFilterTitle(filterParams)}
                </Typography>
              </StyledTableCellTittle>
            </TableRow>
          </TableHead>
          <TableHead>
            <TableRow>
              {typeConsolidation !== 1 && (
                <StyledTableCell align="center">Mois</StyledTableCell>
              )}
              <StyledTableCell align="center">Annee</StyledTableCell>
              <StyledTableCell align="center">Somme CA Budget</StyledTableCell>
              <StyledTableCell align="center">
                Somme Marge valeur budget
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataConsolidationBudget.map((budgetConsolidation) => (
              <TableRow>
                {typeConsolidation !== 1 && (
                  <StyledTableCell>
                    {" "}
                    {
                      AllMounth.find((x) => x.id === budgetConsolidation?.mois)
                        ?.mounth
                    }
                  </StyledTableCell>
                )}
                <StyledTableCell>{budgetConsolidation?.annee}</StyledTableCell>
                <StyledTableCell>
                  {budgetConsolidation?.ca_budget_sum?.toFixed(2)}
                </StyledTableCell>
                <StyledTableCell>
                  {budgetConsolidation?.marge_sum?.toFixed(2)}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {stackAlert}

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      <OptionalWidthModal
        title="Ajout Budget"
        breackPoint="lg"
        onClose={handleClose}
        open={openModal}
      >
        <AddBudgetReforecastForm
          dataPaysInAssociations={dataPaysInAssociations}
          http={http}
          model={model}
          onClose={handleClose}
          reloadList={reloadList}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          dateVerrouillageCloture={dateVerrouillageCloture}
        />
      </OptionalWidthModal>
    </>
  );
};

export default ConsolidationBudget;
